import { useEffect, useState } from "react";

const PartScrollPos = ({ children }) => {
  const [position, setPosition] = useState({ scrollTop: 0 });
  useEffect(() => {
    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() =>
        setPosition({ scrollTop: document.scrollingElement.scrollTop, height: window.innerHeight }),
      );
    };
    setPosition({ scrollTop: document.scrollingElement.scrollTop, height: window.innerHeight });
    window.addEventListener("resize", update);
    document.addEventListener("scroll", update, { capture: true, passive: true });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", update);
      document.removeEventListener("scroll", update, true);
    };
  }, []);
  return children(position);
};
export default PartScrollPos;
